
import { useState, useEffect, useCallback } from 'react';
import { getAppointments, deleteAppointment } from '../services/medicalService';

export interface Appointment {
  id: string;
  pet_id: string;
  user_id: string;
  appointment_type: string;
  appointment_datetime: string;
  status: string;
  vet_name: string | null;
  vet_phone: string | null;
  location: string | null;
  notes: string | null;
  created_at: string;
  updated_at: string;
}

export const useAppointments = (petId: string | undefined) => {
  const [appointments, setAppointments] = useState<Appointment[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!petId) {
      setIsLoading(false);
      return;
    }

    const fetchAppointments = async () => {
      try {
        setIsLoading(true);
        const data = await getAppointments(petId);
        setAppointments(data);
      } catch (err: any) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAppointments();
  }, [petId]);

  const refreshAppointments = useCallback(async () => {
    if (!petId) return;
    try {
      setIsLoading(true);
      const data = await getAppointments(petId);
      setAppointments(data);
    } catch (err: any) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, [petId]);

  const deleteAppointmentRecord = useCallback(async (appointmentId: string) => {
    await deleteAppointment(appointmentId);
    await refreshAppointments();
  }, [refreshAppointments]);

  return { appointments, isLoading, error, refreshAppointments, deleteAppointmentRecord };
};
